import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Materia } from 'src/app/models/materia';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MateriaService } from 'src/app/services/materia.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IdentidadeVisualService } from 'src/app/services/identidade-visual.service';

@Component({
  selector: 'app-cadastrar-materia',
  templateUrl: './cadastrar-materia.component.html',
  styleUrls: ['./cadastrar-materia.component.scss']
})
export class CadastrarMateriaComponent implements OnInit {
  materia: Materia = new Materia();
  idMateria: string;
  thumb = false;

  @ViewChild('matImage', {static: false}) matImage: ElementRef;
  selectedFile: File;

  constructor(
    private utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private materiaService: MateriaService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.data.subscribe(data => {
      this.thumb = data['thumb'];
    });
  }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idMateria = this.route.snapshot.paramMap.get('id');
      this.buscarMateria();
    } else {
      this.materia = new Materia();
      this.materia.ativo = true;
    }
  }

  buscarMateria() {
    this.carregandoService.mostra('buscarMateria');

    this.materiaService.consultarPorId(this.idMateria).subscribe(materia => {
      this.materia = materia;
      this.carregandoService.esconde('buscarMateria');
    }, (erro) => {
      this.carregandoService.esconde('buscarMateria');
      this.notificacaoService.erro(erro);
    });
  }

  onFileChanged(event) {
    if(event.target.files[0].type !== 'image/jpeg') {
      this.matImage.nativeElement.value = null;

      this.notificacaoService.erroMSG('Arquivo inválido, use arquivos com extensão .jpg');
      return;
    } else {
      this.materia.imagem = '';
      this.selectedFile = event.target.files[0];
    }
  }

  excluirArquivo() {
    this.materia.imagem = '';
    this.selectedFile = undefined;
  }

  async salvar() {
    this.carregandoService.mostra('salvarMateria');

    if (this.selectedFile) {
      this.materia.imagem = (await this.utilitarioService.toBase64(this.selectedFile));
    }

    this.materia.thumb = this.thumb ? true : false;

    this.materiaService.salvar(this.materia).subscribe(
      (retorno) => {
        this.notificacaoService.sucesso((this.thumb ? 'Notícia ' : 'Matéria') + ' salva com sucesso!!!');
        this.carregandoService.esconde('salvarMateria');
        this.router.navigate([this.thumb ? 'configuracoes/noticias-economia' : 'configuracoes/materia']);
      },
      (erro) => {
        this.carregandoService.esconde('salvarMateria');
        this.notificacaoService.erro(erro);
      }
    );
  }

  voltar() {
    this.router.navigate([this.thumb ? 'configuracoes/noticias-economia' : 'configuracoes/materia']);
  }
}
